export var CartStatus;
(function (CartStatus) {
    CartStatus["UNKNOWN_CART_STATUS"] = "UNKNOWN_CART_STATUS";
    CartStatus["ACTIVE"] = "ACTIVE";
    CartStatus["COMPLETED"] = "COMPLETED";
    CartStatus["EXPIRED"] = "EXPIRED";
    CartStatus["CANCELED"] = "CANCELED";
})(CartStatus || (CartStatus = {}));
export var DurationUnit;
(function (DurationUnit) {
    /** unknown interval unit */
    DurationUnit["UNKNOWN_UNIT"] = "UNKNOWN_UNIT";
    /** day */
    DurationUnit["DAY"] = "DAY";
    /** week */
    DurationUnit["WEEK"] = "WEEK";
    /** month */
    DurationUnit["MONTH"] = "MONTH";
    /** year */
    DurationUnit["YEAR"] = "YEAR";
})(DurationUnit || (DurationUnit = {}));
export var CycleType;
(function (CycleType) {
    CycleType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    CycleType["ONE_TIME"] = "ONE_TIME";
    CycleType["RECURRING"] = "RECURRING";
})(CycleType || (CycleType = {}));
export var ViolationLevel;
(function (ViolationLevel) {
    /** Error */
    ViolationLevel["ERROR"] = "ERROR";
    /** Warning */
    ViolationLevel["WARNING"] = "WARNING";
})(ViolationLevel || (ViolationLevel = {}));
export var ValidationName;
(function (ValidationName) {
    ValidationName["UNKNOWN"] = "UNKNOWN";
    ValidationName["QUANTITY_IS_POSITIVE"] = "QUANTITY_IS_POSITIVE";
    ValidationName["PRODUCT_IS_PUBLISHED"] = "PRODUCT_IS_PUBLISHED";
    ValidationName["UNIQUE_IN_CONTEXT"] = "UNIQUE_IN_CONTEXT";
    ValidationName["PRODUCT_RELATIONS"] = "PRODUCT_RELATIONS";
    ValidationName["EXTERNAL_VALIDATION"] = "EXTERNAL_VALIDATION";
})(ValidationName || (ValidationName = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map